import { portalRedirectPath, type LoginResponse } from '@/features/auth/login/api'
import { clearPortalSession, persistPortalSession } from '@/lib/auth/portal-session'
import type { PortalKind } from '@/lib/auth/token-storage'

/**
 * 登录成功后统一落本地 session，并把下一步导航意图返回给页面层。
 * 页面层负责真正跳转，这样 session 写入和路由副作用保持分离。
 */
export function persistAuthenticatedSession(portal: PortalKind, response: LoginResponse) {
  if (response.code === 'fail') {
    return undefined
  }

  persistPortalSession(portal, response.data, { source: 'password' })

  if (response.data.password_reset_required) {
    return {
      passwordResetRequired: true,
      redirectPath: portalRedirectPath[portal],
    }
  }

  return {
    passwordResetRequired: false,
    redirectPath: portalRedirectPath[portal],
  }
}

/**
 * 登录失败或显式退出时清理当前门户 session。
 */
export function clearAuthenticatedSession(portal: PortalKind) {
  clearPortalSession(portal)
}
